import styles from "./Hero.module.css";

export default function Hero() {
  return (
    <section className={styles.hero} aria-label="Carrcraft Studio hero">
      <div className={styles.inner}>
        <h1 className={styles.heading}>
          Carrcraft.
           We craft{" "}
          <span className={styles.accent}>
            digital
            <span className={styles.underline} aria-hidden="true" />
          </span>{" "}
          experiences.
        </h1>

        <p className={styles.sub}>
          Carrcraft Studio designs and builds custom iOS & Android apps and
          software solutions — from concept to shipped product.
        </p>

        <div className={styles.actions}>
          <a href="#products" className={styles.btnPrimary}>
            Our Products
          </a>
          <a href="#contact" className={styles.btnSecondary}>
            Work With Us
          </a>
        </div>

        {/* Tech pills */}
        <div className={styles.pills} aria-label="Technologies we use">
          {["React Native", "iOS", "Android", "TypeScript", "Node.js"].map((t) => (
            <span key={t} className={styles.pill}>{t}</span>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className={styles.scrollIndicator} aria-hidden="true">
        <span className={styles.scrollLabel}>scroll</span>
        <div className={styles.scrollLine} />
      </div>
    </section>
  );
}
